import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CONSTANTS from '../utils/constants';
import { useNavigate, useParams } from 'react-router-dom';

export default function AdminBrendEdit() {
    const { id } = useParams(); // URL'den brend ID'sini al
    const navigate = useNavigate();

    const [brendData, setBrendData] = useState({
        name_tm: '',
        name_ru: '',
        name_en: '',
        order_number: 0
    });
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [message, setMessage] = useState({ type: '', text: '' });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBrendData = async () => {
            try {
                // Fetch only the brand being edited
                const response = await axios.get(`${CONSTANTS.baseRoute}/brands/${id}`);
                const brendToEdit = response.data;

                setBrendData({
                    name_tm: brendToEdit.name_tm || '',
                    name_ru: brendToEdit.name_ru || '',
                    name_en: brendToEdit.name_en || '',
                    order_number: brendToEdit.order_number || 0,
                });

                if (brendToEdit.image_path) {
                    setImagePreview(`${CONSTANTS.baseRoute}${brendToEdit.image_path}`);
                }
            } catch (error) {
                console.error("Brend bilgileri çekilirken hata oluştu:", error);
                setMessage({ type: 'danger', text: 'Brend bilgileri yüklenemedi.' });
            } finally {
                setLoading(false);
            }
        };

        fetchBrendData();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBrendData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ type: '', text: '' });

        if (!imagePreview) {
            setMessage({ type: 'danger', text: 'Brend üçin surat hökmanydyr.' });
            return;
        }

        const formData = new FormData();
        formData.append('name_tm', brendData.name_tm);
        formData.append('name_ru', brendData.name_ru);
        formData.append('name_en', brendData.name_en);
        formData.append('order_number', brendData.order_number);

        if (imageFile) {
            formData.append('image', imageFile);
        }

        try {
            const response = await axios.put(`${CONSTANTS.baseRoute}/brands/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setMessage({ type: 'success', text: response.data.message });

            setTimeout(() => {
                navigate(-1);
            }, 1500);
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Bir hata oluştu.';
            setMessage({ type: 'danger', text: errorMessage });
            console.error("Brend güncellenirken hata:", error);
        }
    };

    if (loading) {
        return <div className="admin-main p-4">Ýüklenýär...</div>;
    }

    return (
        <div className="admin-main p-2">
                       <div className="d-flex gap-2 align-items-center mb-2">
                <button className="btn admin-icon-btn" onClick={() => navigate(-1)}>
                    <i className="bi bi-chevron-left"></i>
                </button>
                <button className="btn admin-icon-btn" onClick={() => navigate(+1)}>
                    <i className="bi bi-chevron-right"></i>
                </button>
                <h5 className=" mb-0">Brend düzetmek</h5>
            </div>
            <hr />

            {message.text && (
                <div className={`alert alert-${message.type}`} role="alert">
                    {message.text}
                </div>
            )}

            <form onSubmit={handleSubmit} className="mt-4">
                <div className="row g-3">
                    <div className="col-lg-4 col-md-12">
                        <div className="card h-100">
                            <div className="card-body d-flex flex-column">
                                <h5 className="card-title mb-3">Brend Suraty</h5>
                                <input
                                    type="file"
                                    id="imageUpload"
                                    className="d-none"
                                    accept="image/png, image/jpeg, image/webp"
                                    onChange={handleImageChange}
                                />
                                <label htmlFor="imageUpload" className="image-uploader-box flex-grow-1">
                                    {imagePreview ? (
                                        <img src={imagePreview} alt="Brend Önizleme" />
                                    ) : (
                                        <div className="uploader-placeholder">
                                            <i className="bi bi-image fs-1 text-muted"></i>
                                            <span className="mt-2 text-muted">Surat saýlamak üçin basyň</span>
                                        </div>
                                    )}
                                </label>
                                {!imagePreview && (
                                    <span className='d-flex align-items-center text-danger mt-2' style={{ fontSize: "14px" }}>
                                        Brend üçin surat hökmanydyr.
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-8 col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title mb-4">Brend Maglumatlary</h5>
                                <div className='row'>
                                    <div className="mb-3 col-md-6">
                                        <label htmlFor="name_tm" className="form-label">Brend Ady (TM)</label>
                                        <input type="text" className="form-control" id="name_tm" name="name_tm" value={brendData.name_tm} onChange={handleChange} required />
                                    </div>
                                    <div className="mb-3 col-md-6">
                                        <label htmlFor="name_ru" className="form-label">Brend Ady (RU)</label>
                                        <input type="text" className="form-control" id="name_ru" name="name_ru" value={brendData.name_ru} onChange={handleChange} />
                                    </div>
                                    <div className="mb-3 col-md-6">
                                        <label htmlFor="name_en" className="form-label">Brend Ady (EN)</label>
                                        <input type="text" className="form-control" id="name_en" name="name_en" value={brendData.name_en} onChange={handleChange} />
                                    </div>

                                    <div className="mb-3 col-md-6">
                                        <label htmlFor="order_number" className="form-label">Tertibi</label>
                                        <input type="number" className="form-control" id="order_number" name="order_number" value={brendData.order_number} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end mt-3">
                                    <button type="submit" className="btn btn-primary px-4">Düzetmäni ýatda sakla</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}